package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DomainW500Rounded: ImageVector
    get() {
        if (_domainW500Rounded != null) {
            return _domainW500Rounded!!
        }
        _domainW500Rounded = Builder(name = "DomainW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(72.59f, 760.0f)
                verticalLineToRelative(-552.59f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                quadToRelative(26.6f, -26.61f, 64.39f, -26.61f)
                horizontalLineToRelative(232.82f)
                quadToRelative(37.79f, 0.0f, 64.39f, 26.61f)
                quadToRelative(26.61f, 26.61f, 26.61f, 64.39f)
                verticalLineToRelative(69.0f)
                horizontalLineToRelative(309.0f)
                quadToRelative(37.79f, 0.0f, 64.39f, 26.61f)
                quadToRelative(26.61f, 26.61f, 26.61f, 64.39f)
                lineTo(887.41f, 760.0f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                quadTo(834.2f, 851.0f, 796.41f, 851.0f)
                lineTo(163.59f, 851.0f)
                quadToRelative(-37.79f, 0.0f, -64.39f, -26.61f)
                quadTo(72.59f, 797.78f, 72.59f, 760.0f)
                close()
                moveTo(160.0f, 763.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(160.0f, 603.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(160.0f, 443.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(160.0f, 283.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(320.0f, 763.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(320.0f, 603.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(320.0f, 443.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(320.0f, 283.59f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(480.0f, 763.59f)
                horizontalLineToRelative(320.0f)
                verticalLineToRelative(-400.0f)
                lineTo(480.0f, 363.59f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(640.0f, 523.59f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(-80.0f)
                close()
                moveTo(640.0f, 683.59f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(-80.0f)
                close()
            }
        }
        .build()
        return _domainW500Rounded!!
    }

private var _domainW500Rounded: ImageVector? = null
